import { render, staticRenderFns } from "./ProjectsMap.vue?vue&type=template&id=2336ef22&"
import script from "./ProjectsMap.vue?vue&type=script&lang=js&"
export * from "./ProjectsMap.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports